import { Link } from "react-router-dom";
import { MessageCircle, Bot, CalendarCheck, ListChecks, ArrowDown, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const flow = [
  { icon: MessageCircle, label: "Client WhatsApp" },
  { icon: Bot, label: "Assistant ActiPilote" },
  { icon: ListChecks, label: "Disponibilités & informations" },
  { icon: CalendarCheck, label: "Réservation ActiPilote" },
];

const Addons = () => (
  <section data-testid="addons-section" id="options" className="scroll-mt-24 pb-16 sm:pb-24 lg:pb-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="mx-auto max-w-2xl text-center">
        <Eyebrow>Options</Eyebrow>
        <h2 className="mt-4 text-balance text-3xl font-bold tracking-tight text-navy sm:text-4xl">
          Allez encore plus loin avec ActiPilote.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-navy/60 sm:text-lg">
          Ajoutez des fonctionnalités avancées à votre abonnement selon les besoins de votre activité.
        </p>
      </Reveal>

      <div className="mx-auto mt-14 grid max-w-4xl gap-5 md:grid-cols-1">
        <Reveal>
          <div data-testid="addon-whatsapp-ia" className="relative overflow-hidden rounded-3xl border border-slate-200 bg-navy p-7 shadow-lift sm:p-10">
            <div className="pointer-events-none absolute -right-20 -top-20 h-56 w-56 rounded-full bg-turquoise/15 blur-[90px]" aria-hidden="true" />
            <div className="pointer-events-none absolute -bottom-24 -left-16 h-56 w-56 rounded-full bg-brand/20 blur-[90px]" aria-hidden="true" />

            <div className="relative flex flex-wrap items-center gap-3">
              <span data-testid="addon-badge-coming-soon" className="rounded-full bg-turquoise px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.14em] text-navy">
                Bientôt disponible
              </span>
              <span className="text-xs font-semibold text-white/50">En complément d'un abonnement ActiPilote.</span>
            </div>

            <div className="relative mt-6 flex flex-wrap items-center justify-between gap-4">
              <h3 className="text-2xl font-bold text-white">Assistant IA WhatsApp</h3>
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/10 text-turquoise">
                <MessageCircle className="h-6 w-6" />
              </span>
            </div>

            <p className="relative mt-5 max-w-xl text-sm leading-relaxed text-white/70 sm:text-base">
              Automatisez demain une partie de vos échanges WhatsApp. L'assistant ActiPilote pourra
              renseigner vos clients sur vos activités, consulter les informations utiles et transformer
              leurs demandes en réservations directement dans ActiPilote.
            </p>

            <div className="relative mt-8 grid gap-2 sm:grid-cols-4 sm:gap-3">
              {flow.map((f, i) => (
                <div key={f.label} className="flex items-center gap-3 sm:flex-col sm:items-start">
                  <div className="flex w-full items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3">
                    <f.icon className="h-4 w-4 shrink-0 text-turquoise" />
                    <span className="text-xs font-bold text-white/85">{f.label}</span>
                  </div>
                  {i < flow.length - 1 && (
                    <ArrowDown className="ml-6 h-4 w-4 shrink-0 text-white/25 sm:hidden" aria-hidden="true" />
                  )}
                </div>
              ))}
            </div>

            <div className="relative mt-8">
              <Link
                to="/contact?sujet=assistant-ia"
                data-testid="addon-waitlist-cta"
                className="group inline-flex items-center gap-2 rounded-full bg-turquoise px-6 py-3 text-sm font-bold text-navy transition-all duration-300 hover:-translate-y-0.5 hover:brightness-110"
              >
                Être informé du lancement
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Addons;
